<template>
    <Row type="form-row">

        <!-- amount -->
        <InputBox
                :model-form="modelForm"
                :model-name="modelName"
                :errors="errors"
                check-to-model="modelIntState"
                title="amount"
                type="number"
                :xs-size="xsSize"
                :sm-size="smSize"
        />

        <Column v-if="showColumn" xs-size="2" sm-size="5">
            <MarginTop size="2" />
            <LabelTag color="light"> - </LabelTag>
            <span v-if="product">{{ showUnitOfMeasure(product.unitOfMeasure) }}</span>
        </Column>

    </Row>
</template>

<script>
    import validatorMixin from "../mixin/validatorMixin";
    import Row from "./html/Row";
    import InputBox from "./InputBox";
    import Column from "./html/Column";
    import {mapGetters} from "vuex";
    import LabelTag from "./html/LabelTag";
    import MarginTop from "./html/MarginTop";
    import currencyFormat from "@/mixin/currencyFormatMixin";

    export default {
        name: "Amount",
        components: {MarginTop, LabelTag, Column, InputBox, Row},
        mixins: [validatorMixin, currencyFormat],
        props: {
            modelForm: {
                type: Object,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            },

            // optional
            modelName: {
                type: String,
                default: "amount",
            },
            productModelName: {
                type: String,
                default: "productId"
            },
            smSize: {
                type: String,
                default: "5"
            },
            xsSize: {
                type: String,
                default: "10"
            },
            showColumn: {
                type: Boolean,
                default: true
            }
        },

        computed: {
            ...mapGetters(['findProduct']),
            product: {
                get() {
                    return this.findProduct(this.modelForm[this.productModelName])
                }
            },
        },
    }
</script>

<style scoped>

</style>